import styled from '@emotion/styled';
import useHandleApi from 'hooks/useHandleApi';
import { useEffect, useState } from 'react';
import useBrandStore from 'stores/useBrandStore';
import LoadingSpinner from 'ui/LoadingSpinner';
import CustomerOverviewView from './CustomerOverview.View';

const LoadingSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
`;

const CustomerOverview = () => {
  const apiDomain = import.meta.env.VITE_PLATFORM_API_URL;
  const { brand } = useBrandStore();
  const [brandPersonasData, setBrandPersonasData] = useState({
    personasData: {
      personas: [],
      overall_population: [],
      other_brands_analysis: {
        specialized_tag_types: []
      }
    },
    other_brands_analysis: {
      specialized_tag_types: []
    },
    crossBrandPurchases: []
  });

  const { handleApi, loading: personasLoading } = useHandleApi({ apiDomain });

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    const fetchBrandPersonas = async () => {
      const brandPersonasResponse = await handleApi({
        endpoint: `/brand/${brand.brandId}/persona`,
        method: 'GET',
        skipErrorToaster: true
      });

      const crossBrandPurchasesResponse = await handleApi({
        endpoint: `/brand/${brand.brandId}/personas-cross-brand-purchases`,
        method: 'GET',
        skipErrorToaster: true
      });

      setBrandPersonasData({
        personasData: brandPersonasResponse.data.data,
        other_brands_analysis: brandPersonasResponse.data.data.other_brands_analysis,
        crossBrandPurchases: crossBrandPurchasesResponse.data
      });
    };
    fetchBrandPersonas();
  }, [brand.brandId]);

  if (personasLoading) {
    return (
      <LoadingSpinnerWrapper>
        <LoadingSpinner />
      </LoadingSpinnerWrapper>
    );
  }

  const crossBrandPurchaseOtherProducts = brandPersonasData.crossBrandPurchases?.find(
    (item: Record<string, unknown>) => item.purchaseType === 'others_products'
  );

  const brandProducts =
    (crossBrandPurchaseOtherProducts &&
      (
        crossBrandPurchaseOtherProducts as {
          data?: { top_100_other_brand_products?: Record<string, unknown>[] };
        }
      ).data?.top_100_other_brand_products) ||
    [];

  return (
    <CustomerOverviewView brandProducts={brandProducts} brandPersonasData={brandPersonasData} />
  );
};

export default CustomerOverview;
